/** Body class toggled while the fixed support bar is visible (padding + footer offset). */
export const IMPERSONATION_BANNER_BODY_CLASS = "impersonation-banner-active";

export const formatImpersonationRemainingTime = (
  milliseconds: number
): string => {
  if (milliseconds <= 0) {
    return "00:00";
  }

  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};
